// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ie5A","label":"styles_label__2F4QC"};